








import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ProductStatusBadge extends Vue {
  @Prop({ required: true, type: Boolean })
  isActive!: boolean;
}
